// utils/dateFormatter.js
import { parseISO } from 'date-fns';
import { formatInTimeZone } from 'date-fns-tz';

const ATLANTIC_TIMEZONE = 'America/Halifax';

/**
 * Format UTC timestamp to Atlantic Time
 * @param {string} utcTimestamp - UTC timestamp from database
 * @param {string} formatType - 'full', 'compact', 'iso', 'date-only', 'time-only'
 * @returns {string} Formatted timestamp in Atlantic Time
 */
export const formatToAtlanticTime = (utcTimestamp, formatType = 'full') => {
  if (!utcTimestamp) return 'N/A';

  try {
    const date = parseISO(utcTimestamp);

    switch (formatType) {
      case 'full':
        return formatInTimeZone(date, ATLANTIC_TIMEZONE, `MMM d, yyyy 'at' h:mm a`) + ` AT`;

      case 'compact':
        return formatInTimeZone(date, ATLANTIC_TIMEZONE, `MMM d, yyyy, h:mm a`) + ` AT`;

      case 'iso':
        return formatInTimeZone(date, ATLANTIC_TIMEZONE, `yyyy-MM-dd HH:mm`) + ` AT`;

      case 'date-only':
        return formatInTimeZone(date, ATLANTIC_TIMEZONE, 'MMM d, yyyy');

      case 'time-only':
        return formatInTimeZone(date, ATLANTIC_TIMEZONE, `h:mm a`) + ` AT`;

      default:
        return formatInTimeZone(date, ATLANTIC_TIMEZONE, `MMM d, yyyy 'at' h:mm a`) + ` AT`;
    }
  } catch (error) {
    console.error('Error formatting timestamp:', error);
    return 'Invalid Date';
  }
};
